import * as React from 'react';

import { Color, IconName } from '../../enums';
import { Icon } from '../icon/icon.component';

import { Container, IconContainer, Message, MessageContainer } from './messageBox.styled';
import { MessageBoxProps } from './messageBox.types';

export const MessageBox: React.FC<MessageBoxProps> = (props: MessageBoxProps): JSX.Element => {
  const { message, className }: MessageBoxProps = props;

  return (
    <Container className={className}>
      <IconContainer>
        <Icon name={IconName.Danger} size={22} color={Color.Error500} />
      </IconContainer>
      <MessageContainer>
        <Message>{message}</Message>
      </MessageContainer>
    </Container>
  );
};
